import { Door } from "./door";

export class Maps {
	self: Phaser.Tilemaps.Tilemap;
	collision: Phaser.Tilemaps.StaticTilemapLayer;
	map: Phaser.Tilemaps.StaticTilemapLayer;
	tileset1: Phaser.Tilemaps.Tileset;
	tileset2: Phaser.Tilemaps.Tileset;
	doors: Phaser.GameObjects.Group;

	music: Phaser.Sound.BaseSound;
	deathSong: Phaser.Sound.BaseSound;
	playMusicFlag: boolean;
	deathSongFlag: boolean;

	navMesh: any;
	constructor() {
		// super();
	}
	preload(scene: Phaser.Scene): void {
		scene.load.image("plains_extruded", "release_assets/plains_extruded.png");
		scene.load.image("plains_physics", "release_assets/physics_32.png");
		scene.load.tilemapTiledJSON("plains_tilemap", "release_assets/plains.json");
		// scene.load.image("infinite_tiles", "assets/azul_tile2.png");
		// scene.load.image("azul_tile2_extruded", "azul_tile2_extruded.png");
		// scene.load.image("infinite_physics", "assets/physics.png");

		// scene.load.tilemapTiledJSON("infinite_map", "assets/infinite.json");

		// SOUND!
		scene.load.audio("backgroundMusic", [
		 	"release_assets/sound/levelTheme.wav"
		],{
			volume: 0.1
		});

		// SOUND!
		scene.load.audio("deathMusic", [
			"release_assets/sound/deathSong.wav"
	   ],{
		volume: 0.1
	});
	}
	create(scene: ExtendedScene): void {
		this.self = scene.make.tilemap({ key: "plains_tilemap" });

		this.tileset1 = this.self.addTilesetImage(
			"plains_extruded",
			"plains_extruded",
			32,
			32,
			1,
			2
		);
		this.tileset2 = this.self.addTilesetImage("physics_32", "plains_physics");
		this.map = this.self.createStaticLayer("Map", this.tileset1, 0, 0);
		this.collision = this.self.createStaticLayer("Collision", this.tileset2, 0, 0);
		this.collision.setAlpha(0);

		// this.collision.resizeWorld();
		this.collision.setCollision(65);
		const objectLayer: any = this.self.getObjectLayer("navmesh");
		this.navMesh = scene.navMeshPlugin.buildMeshFromTiled("mesh", objectLayer, 16);

		const config: Phaser.Types.Sound.SoundConfig = {
			volume: 0.25
		};

		this.music = scene.sound.add("backgroundMusic", config);
		this.playMusicFlag = true;

		this.deathSong = scene.sound.add("deathMusic", config);
		this.deathSongFlag = false;;
	}

	update(
		time: number,
		delta: number,
		scene: Phaser.Scene,
		player: Phaser.Physics.Arcade.Sprite
	): void {
		// no update function?

		if (!this.music.isPlaying && this.playMusicFlag) {
			this.music.play();
		} else if(this.music.isPlaying && !this.playMusicFlag) {
			this.music.stop();
		}
	}

	stopBackgroundMusic(): void {
		this.playMusicFlag = false;
		this.music.stop();
	}

	playDeathMusic(): void {
		if (!this.deathSong.isPlaying && !this.deathSongFlag) {
			this.deathSong.play();
			this.deathSongFlag = true;
		}
	}

	deathSongReset(): void {
		this.deathSongFlag = false;
	}
}
